<template>
  <div>
    <section class="hero">
      <div class="hero-content">
        <img src="../assets/condena_eterna.jpg" alt="La Biblia Completa de Gogo" class="bot-icon" />
        <h1>La Biblia Completa de Gogo Saporu</h1>
        <p>Los textos sagrados expandidos de la divinidad</p>
      </div>
    </section>

    <AdSense />

    <div class="page-container">
      <div v-if="loading" class="loading">
        <p>Cargando los textos sagrados...</p>
      </div>
      
      <div v-else-if="error" class="error">
        <p>Error al cargar los textos sagrados: {{ error }}</p>
      </div>
      
      <div v-else class="biblia-content" v-html="bibliaContent"></div>
      
      <div class="navigation">
        <router-link to="/condena" class="btn-volver">← Volver a la Condena</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AdSense from './AdSense.vue';

export default {
  components: {
    AdSense
  },
  name: "AppCondenaExtendida",
  data() {
    return {
      bibliaContent: '',
      loading: true,
      error: null
    }
  },
  async mounted() {
    await this.loadGoogleDocContent();
  },
  methods: {
    async loadGoogleDocContent() {
      try {
        this.loading = true;
        this.error = null;
        
        // ID del documento extraído de la URL
        const docId = '1nkgWkWvD5QGc1Rctp8CYMrwj93aeC1hP9wWs59BJp44';
        
        // URL para obtener el documento como HTML
        const docUrl = `https://docs.google.com/document/d/${docId}/export?format=html`;
        
        // Usar un proxy CORS o servidor propio para evitar problemas de CORS
        const response = await fetch(docUrl);
        
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        
        const html = await response.text();
        
        // Procesar el HTML y extraer tanto los estilos como el cuerpo
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // 1. Extraer los estilos originales del head de Google Docs
        const styleElements = doc.querySelectorAll('style');
        let gdocStyles = '';
        styleElements.forEach(styleEl => {
          gdocStyles += styleEl.textContent;
        });
        
        // 2. Extraer el contenido del body
        const bodyContent = doc.body;
        if (bodyContent) {
          // Remover scripts e iframes potencialmente inseguros
          const scripts = bodyContent.querySelectorAll('script');
          scripts.forEach(el => el.remove());
          const iframes = bodyContent.querySelectorAll('iframe');
          iframes.forEach(el => el.remove());
          
          // Obtener las clases y estilos del elemento body original de Google Docs
          const bodyClass = bodyContent.getAttribute('class') || '';
          const bodyStyle = bodyContent.getAttribute('style') || '';
          
          // Acotar los estilos de Google Docs para que no alteren la barra de navegación o elementos globales
          let scopedStyles = gdocStyles
            .replace(/\bbody\s*\{/gi, '.biblia-content-container {')
            .replace(/\bhtml\s*\{/gi, '.biblia-content-html-disabled {');
            
          // Inyectamos los estilos originales adaptados junto con el HTML estructurado
          this.bibliaContent = `
            <style>
              ${scopedStyles}
              /* Garantizar compatibilidad con imágenes responsivas */
              .biblia-content-container img {
                max-width: 100% !important;
                height: auto !important;
                border: 2px solid #5c3a21;
                border-radius: 4px;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);
              }
              /* Sobrescribir colores de Google Docs para el modo pergamino oscuro */
              .biblia-content-container,
              .biblia-content-container * {
                background-color: transparent !important;
                color: #e3d2be !important; /* Tono hueso / pergamino viejo */
                font-family: 'Georgia', 'Garamond', serif !important;
              }
              /* 1. Titular inicial a la izquierda y de tono canela/cobre cálido */
              .biblia-content-container h1,
              .biblia-content-container h1 *,
              .biblia-content-container .title,
              .biblia-content-container .title *,
              .biblia-content-container .gdoc-title-1,
              .biblia-content-container .gdoc-title-1 * {
                color: #c08552 !important; /* Canela/cobre antiguo */
                text-align: left !important;
                font-size: 2.3rem !important;
                text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.9) !important;
                font-family: 'Georgia', 'Garamond', serif !important;
                font-weight: bold !important;
                border-bottom: 2px solid #5c3a21 !important;
                padding-bottom: 0.8rem;
                margin-top: 1rem !important;
                margin-bottom: 2rem !important;
              }
              /* 2. Subtítulos menores en el mismo tono canela/cobre cálido */
              .biblia-content-container h2,
              .biblia-content-container h2 *,
              .biblia-content-container h3,
              .biblia-content-container h3 *,
              .biblia-content-container h4,
              .biblia-content-container h4 *,
              .biblia-content-container .subtitle,
              .biblia-content-container .subtitle *,
              .biblia-content-container .gdoc-title-2,
              .biblia-content-container .gdoc-title-2 *,
              .biblia-content-container .gdoc-title-3,
              .biblia-content-container .gdoc-title-3 * {
                color: #c08552 !important; /* Canela/cobre antiguo (marrón cálido de diferente intensidad) */
                text-align: left !important;
                font-size: 1.55rem !important;
                font-family: 'Georgia', 'Garamond', serif !important;
                font-weight: bold !important;
                border-bottom: 1px dashed rgba(192, 133, 82, 0.3) !important;
                padding-bottom: 0.4rem;
                margin-top: 2.5rem !important;
                margin-bottom: 1rem !important;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8) !important;
              }
              /* Aislamiento y diseño del contenedor de lectura - ESTILO PERGAMINO OSCURO */
              .biblia-content-container {
                padding: 4rem 3rem !important;
                border-radius: 8px;
                /* Textura de pergamino oscuro rústico */
                background: linear-gradient(135deg, #1f140e 0%, #150d09 100%) !important;
                border: 2px solid #3d2414;
                box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8), inset 0 0 60px rgba(0, 0, 0, 0.9);
                overflow-x: auto;
                margin: 0 auto;
                max-width: 900px;
                line-height: 1.9 !important;
                text-align: justify;
                font-size: 1.15rem !important;
              }
              /* Enlaces estilizados como notas al pie místicas */
              .biblia-content-container a {
                color: #ffaa44 !important;
                text-decoration: underline !important;
              }
              .biblia-content-container a:hover {
                color: #ffcc66 !important;
              }
              /* Espaciado del diario */
              .biblia-content-container p {
                margin-bottom: 1.8rem !important;
                text-indent: 1.5rem;
              }
            </style>
            <div class="biblia-content-container ${bodyClass}" style="${bodyStyle}">
              ${bodyContent.innerHTML}
            </div>
          `;
        } else {
          throw new Error('No se pudo extraer el contenido del documento');
        }
        
      } catch (error) {
        console.error('Error loading Google Doc:', error);
        this.error = error.message;
        
        // Contenido de fallback en caso de error
        this.bibliaContent = `
          <h2>Los Textos Sagrados</h2>
          <p><em>En caso de que no se puedan cargar los textos desde Google Drive, aquí están algunos fragmentos adicionales:</em></p>
          <p>La sabiduría de Gogo trasciende los límites de la comprensión mortal. En estos textos expandidos, encontramos las enseñanzas más profundas de la divinidad.</p>
          <p>Para acceder al contenido completo, visita directamente: <a href="https://docs.google.com/document/d/1nkgWkWvD5QGc1Rctp8CYMrwj93aeC1hP9wWs59BJp44/edit?usp=sharing" target="_blank">La Biblia Completa de Gogo</a></p>
        `;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #2c1810 0%, #8b4513 100%);
  padding: 4rem 0;
  text-align: center;
}

.hero-content {
  margin: 0 auto;
  padding: 0 2rem;
}

.bot-icon {
  width: 150px;
  height: 150px;
  border-radius: 10px;
  margin-bottom: 2rem;
}

h1 {
  color: #ffd700;
  font-size: 3rem;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  text-align: center !important;
}

.hero p {
  color: #ddd;
  font-size: 1.2rem;
  margin-top: 1rem;
}

.page-container {
  margin: 0 auto;
  padding: 2rem;
  background-color: #1a1a1a;
  color: #fff;
  min-height: 70vh;
}

.loading, .error {
  text-align: center;
  padding: 3rem;
  font-size: 1.2rem;
}

.error {
  color: #ff6b6b;
}

.biblia-content {
  line-height: 1.8;
  font-size: 1.1rem;
  max-width: 100%;
}

/* Estilos para elementos de Google Docs */
.biblia-content .gdoc-title-1 {
  color: #ffd700;
  font-size: 2.5rem;
  font-weight: bold;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.biblia-content .gdoc-title-2 {
  color: #ffed4a;
  font-size: 2rem;
  font-weight: bold;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
}

.biblia-content .gdoc-title-3 {
  color: #f39c12;
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 0.8rem;
}

.biblia-content .gdoc-paragraph {
  color: #fff;
  margin-bottom: 1.5rem;
  text-align: justify;
  line-height: 1.8;
}

.biblia-content .gdoc-bold {
  color: #ffd700;
  font-weight: bold;
}

.biblia-content .gdoc-italic {
  color: #ddd;
  font-style: italic;
}

/* Fallback para elementos estándar de Google Docs */
.biblia-content h1, .biblia-content h2, .biblia-content h3 {
  color: #ffd700;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.biblia-content p {
  margin-bottom: 1.5rem;
  text-align: justify;
}

.biblia-content a {
  color: #87ceeb;
  text-decoration: none;
}

.biblia-content a:hover {
  text-decoration: underline;
}

.navigation {
  margin-top: 3rem;
  text-align: center;
}

.btn-volver {
  background-color: #8b4513;
  color: white;
  padding: 0.8rem 1.5rem;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.btn-volver:hover {
  background-color: #a0522d;
}
</style>
